module.exports = __webpack_public_path__ + "static/media/recibo.e2077f89.png";